import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import Radium, {Style} from 'radium';

import {imageUrl} from '../../../utilities/requests';
import * as styles from '../../../styles';
import StudentReport from './student.js';

//Radium(ManagerReport);
export default class ManagerReport extends React.PureComponent {
    static contextTypes = {
        store: PropTypes.object,
    }

    state = {
        print: false,
        class: 'school',
    }

    constructor(props) {
        super(props);
    }

    componentDidUpdate(prevProps, prevState) {
        if (!prevState.print && this.state.print) {
            window.scrollTo(0, 0);
            window.print();
            this.setState({print: false});
        }
    }

    render() {
        if (!this.props.data || !this.props.students || !this.props.examination)
            return null;
        if (this.state.student)
            return <span>
                <div
                    style={{
                        ...styles.button,
                        float: 'right',
                        marginLeft: '1em',
                    }}
                    onClick={() => this.setState({student: null})}>
                    {window.gettext('Back')}
                </div>
                <StudentReport examination={this.props.examination} student={this.state.student}/>
            </span>;
        return <span>
            <div style={{marginBottom: '.5em'}}>
                <button
                    key='print'
                    style={{...styles.defaultButton, backgroundColor: styles.fourthColor, float: 'left'}}
                    onClick={() => this.setState({print: true})}>
                    {window.gettext('Print')}
                </button>&nbsp;
                {window.gettext('Choose class')}:&nbsp;
                {_.map(
                    _.filter(
                        this.props.school.classes,
                        clazz => _.some(this.props.data, d => d.clazz === clazz.id),
                    ),
                    clazz => <button
                        key={clazz.id}
                        style={{
                            ...(this.state.class === Number.parseInt(clazz.id)
                                ? styles.activeButton
                                : styles.button),
                            marginLeft: '.5em',
                        }}
                        onClick={() => this.setState({class: Number.parseInt(clazz.id), className: window.gettext('Class')})}>
                        {(clazz.name || window.gettext('No Name')).persian()}
                    </button>,
                )}
                <button
                    style={this.state.class === 'school' ? styles.activeButton : styles.button}
                    onClick={() => this.setState({class: 'school', className: window.gettext('School')})}>
                    {window.gettext('School')}
                </button>
            </div>
            <span>
                <div
                    style={{
                        ...styles.box,
                        width: '100%',
                        overflow: 'hidden',
                    }}>
                    <div style={{float: 'right', width: '25%'}}>
                        {window.gettext('Examination')}: {this.props.examination.title}
                    </div>
                    <div style={{float: 'right', width: '25%'}}>
                        {window.gettext('School Name')}: {this.props.school.name}
                    </div>
                    <div style={{float: 'right', width: '25%'}}>
                        {window.gettext('City')}: {this.props.school.city.name}
                    </div>
                    <div style={{float: 'right', width: '25%'}}>
                        {window.gettext('Grade')}: {this.props.examination.grades[0].title}
                    </div>
                    <div style={{float: 'right', width: '25%'}}>
                        {window.gettext('Holding Date')}: {this.props.examination.date.toJalali().persian()}
                    </div>
                    <div style={{float: 'right', width: '25%'}}>
                        {window.gettext('Centers Participated')}:
                        &nbsp;
                        {(this.props.examination.schools_participated || '').persian()}
                    </div>
                    <div style={{float: 'right', width: '25%'}}>
                        {window.gettext('Participants')}: {(this.props.examination.students_participated || '').persian()}
                    </div>
                </div>
                <span
                    style={{
                        '@media screen': {
                            display: 'none',
                        },
                        '@media print': {
                            visibility: 'visible',
                        },
                        lineHeight: '2em',
                    }}>
                    <div
                        style={{
                            position: 'fixed',
                            top: '25mm',
                            right: '44mm',
                            width: '52mm',
                            fontSize: '1.65em',
                        }}>
                        <div style={{textAlign: 'center'}}>
                            <b>{window.gettext('Manager Report')}</b>
                        </div>
                    </div>
                    <div
                        style={{
                            position: 'fixed',
                            top: '8mm',
                            right: '102mm',
                            width: '63.2mm',
                        }}>
                        <div style={{overflow: 'hidden', whiteSpace: 'nowrap', height: '2.3em'}}>
                            <b>{window.gettext('School Name')}:</b>&nbsp;
                            {this.props.school.name} - {this.props.school.city.name}
                        </div>
                        <div style={{overflow: 'hidden', whiteSpace: 'nowrap', height: '2.3em', fontSize: '.9em'}}>
                            <b>{window.gettext('Examination')} - {window.gettext('Grade')}:</b>&nbsp;
                            {this.props.examination.title} - {this.props.examination.grades[0].title}
                        </div>
                        <div style={{overflow: 'hidden', whiteSpace: 'nowrap', height: '2.3em'}}>
                            <b>{window.gettext('Holding Date')}:</b> {this.props.examination.date.toJalali().persian()}
                        </div>
                    </div>
                    <div
                        style={{
                            position: 'fixed',
                            top: '8mm',
                            right: '167mm',
                            width: '42mm',
                        }}>
                        <div style={{overflow: 'hidden', whiteSpace: 'nowrap', height: '2.3em'}}>
                            <b>{window.gettext('Participants')}:</b>
                            &nbsp;
                            {(this.props.examination.students_participated || '').persian()}
                        </div>
                        <div style={{overflow: 'hidden', whiteSpace: 'nowrap', height: '2.3em'}}>
                            <b>{window.gettext('Centers Participated')}:</b>
                            &nbsp;
                            {(this.props.examination.schools_participated || '').persian()}
                        </div>
                        <div style={{overflow: 'hidden', whiteSpace: 'nowrap', height: '2.3em'}}>
                            <b>{window.gettext('Rank Among Schools')}:</b>
                            &nbsp;
                            {(_.find(this.props.data, data => (
                                data.category_is_global &&
                                data.school === this.props.school.id &&
                                data.field === 31 &&
                                data.group_is_global
                            )) || {value: 0}).value.toFixed().persian()}
                        </div>
                    </div>
                    <img
                        style={{
                            position: 'fixed',
                            top: '4mm',
                            right: '4.5mm',
                            width: '33mm',
                        }}
                        src={imageUrl(window.images.logo, {
                            width: 200,
                            type: 'contain',
                        })}
                    />
                    {/* <div */}
                    {/*     style={{ */}
                    {/*         position: 'fixed', */}
                    {/*         top: '195mm', */}
                    {/*         right: '16mm', */}
                    {/*         width: '71mm', */}
                    {/*     }}> */}
                    {/*     <div style={{overflow: 'hidden', height: '2.3em'}}> */}
                    {/*         <b>{window.gettext('Analyze Date')}:</b> {(this.props.examination.analyze_date || '').persian()} */}
                    {/*     </div> */}
                    {/* </div> */}
                    {/* <div */}
                    {/*     style={{ */}
                    {/*         position: 'fixed', */}
                    {/*         top: '195mm', */}
                    {/*         right: '120mm', */}
                    {/*         fontSize: '1.3em', */}
                    {/*         fontFamily: 'Arial', */}
                    {/*     }}> */}
                    {/*     <b>www.mhelli.ir</b> */}
                    {/* </div> */}
                    <Style
                        rules={{
                            '@page': {
                                size: 'A4 Portrait',
                                marginTop: '0',
                                marginLeft: '0',
                                marginRight: '0',
                                marginBottom: '25mm',
                            },
                            ['.' + this.state.classId + ' thead tr']: {
                                borderTop: styles.table.border,
                            },
                            mediaQueries: {
                                print: {
                                    '*': {
                                        backgroundColor: 'unset !important',
                                    },
                                    body: {
                                        visibility: 'hidden',
                                    },
                                    '.page': {
                                        minHeight: 'unset',
                                    },
                                },
                            },
                        }}>
                    </Style>
                </span>
            </span>
            <div
                style={{'@media screen': {
                    ...styles.box,
                    marginTop: '1em',
                    fontSize: `${.125 - Math.max(_.size(this.props.examination.materials), 7) * .06}em`,
                    overflowX: 'scroll',
                }}}>
                <div style={{position: 'relative', width: '20em'}}>
                    <input
                        style={styles.field}
                        placeholder={window.gettext('Search')}
                        value={this.state.filter || ''}
                        onChange={({target: {value}}) => this.setState({filter: value.persian()})}
                    />
                    <i
                        style={{
                            position: 'absolute',
                            left: '.5em',
                            top: '0',
                            height: 'calc(100% - 1em)',
                            display: 'flex',
                            alignItems: 'center',
                        }}
                        className='fa-search'>
                    </i>
                </div>
                <div
                    className={this.state.classId}
                    style={{'@media print': {
                        visibility: 'visible',
                        position: 'absolute',
                        top: '.1mm',
                        left: '12mm',
                        right: '7mm',
                    }}}>
                    <table style={styles.table}>
                        <thead>
                            <th
                                column='school-rank'
                                style={{...styles.th, width: '3em'}}>
                                {window.gettext('Rank')}
                            </th>
                            <td
                                column='name'
                                style={{...styles.th, width: '15em'}}>
                                {window.gettext('Name')}
                            </td>
                            <td
                                column='class'
                                style={{...styles.th, width: '3em'}}>
                                {window.gettext('Class')}
                            </td>
                            <th
                                column='score'
                                style={{
                                    ...styles.th,
                                    width: '4em',
                                }}>
                                {window.gettext('Score')}
                            </th>
                            <th
                                column='status'
                                style={{
                                    ...styles.th,
                                    width: '7em',
                                }}>
                                {window.gettext('Status')}
                            </th>
                            <th
                                column='global-rank'
                                style={{
                                    ...styles.th,
                                    width: '3em',
                                }}>
                                {window.gettext('Global Rank')}
                            </th>
                        </thead>
                        {_.map(
                            _.filter(
                                this.props.students,
                                student => (
                                    (this.state.class === 'school' || student.clazz === this.state.class) &&
                                    _.some(this.props.data, item => item.student === student.id)
                                ),
                            ),
                            (student, index) => <tr style={styles.th} key={index}>
                                <td
                                    column='school-rank'
                                    style={{...styles.td, width: '3em'}}
                                    value={(_.find(this.props.data, data => (
                                        data.category_is_global &&
                                        data.student === student.id &&
                                        data.field === 31 &&
                                        data.group_school === this.props.school.id
                                    )) || {value: 0}).value}>
                                    {(_.find(this.props.data, data => (
                                        data.category_is_global &&
                                        data.student === student.id &&
                                        data.field === 31 &&
                                        data.group_school === this.props.school.id
                                    )) || {value: 0}).value.persian()}
                                </td>
                                <td
                                    column='name'
                                    style={{
                                        ...styles.td,
                                        width: '15em',
                                        textAlign: 'right',
                                        cursor: 'pointer',
                                        color: '#4078c0',
                                        fontWeight: '500',
                                    }}
                                    value={`${student.firstname} ${student.lastname}`}
                                    handleClick={() => this.setState({student: student.id})}>
                                    <span style={{'@media print': {color: 'black'}}}>
                                        {`${student.firstname} ${student.lastname}`}
                                    </span>
                                </td>
                                <td
                                    column='class'
                                    style={{...styles.td, width: '3em'}}
                                    value={_.find(
                                        this.props.school.classes,
                                        item => item.id === student.clazz,
                                    ).name}
                                    handleClick={() => this.setState({student: student.id})}>
                                    {_.find(
                                        this.props.school.classes,
                                        item => item.id === student.clazz,
                                    ).name.persian()}
                                </td>
                                <td
                                    column='score'
                                    style={{...styles.td, width: '4em'}}
                                    value={_.sumBy(
                                        _.filter(this.props.results, item => item.student === student.id),
                                        'mark',
                                    )}>
                                    {_.sumBy(
                                        _.filter(this.props.results, item => item.student === student.id),
                                        'mark',
                                    ).persian()}
                                </td>
                                <td
                                    column='status'
                                    style={{...styles.td, width: '7em'}}
                                    value={_.sumBy(
                                        _.filter(this.props.results, item => item.student === student.id),
                                        'mark',
                                    )}>
                                    {_.sumBy(
                                        _.filter(this.props.results, item => item.student === student.id),
                                        'mark',
                                    ).scoreStatus(_.sumBy(
                                        this.props.examination.questions,
                                        item => _.sumBy(item.scores, 'score'),
                                    ))}
                                </td>
                                <td
                                    column='global-rank'
                                    style={{...styles.td, width: '3em'}}
                                    value={(_.find(this.props.data, data => (
                                        data.category_is_global &&
                                        data.student === student.id &&
                                        data.field === 31 &&
                                        data.group_is_global
                                    )) || {value: 0}).value}>
                                    {(_.find(this.props.data, data => (
                                        data.category_is_global &&
                                        data.student === student.id &&
                                        data.field === 31 &&
                                        data.group_is_global
                                    )) || {value: 0}).value.persian()}
                                </td>
                            </tr>,
                        )}
                    </table>
                </div>
            </div>
        </span>;
    }
};
